// extracted by mini-css-extract-plugin
export default {"listTitleContainer":"GuidelinePage_listTitleContainer__RNn9I","menu":"GuidelinePage_menu__SnVMJ","item":"GuidelinePage_item__dNWyR"};